import type { Traducao } from '../tipos';

/** Textos de `dashboard`. Preenchido pela tradução da área — ver ../README.md. */
export const dashboard: Traducao = {
  pt: {
    titulo: 'Dashboard de Ativos',
    subtitulo: 'Lista de todas as máquinas e equipamentos cadastrados',
    acoes: {
      novaMaquina: 'Nova Máquina',
      importar: 'Importar Planilha',
      importando: 'Importando...',
    },
    filtros: {
      titulo: 'Filtros',
      limpar: 'Limpar Filtros',
      busca: 'Busca',
      buscaPlaceholder: 'Equipamento, TAG, Item...',
      apenasComApreciacoes: 'Apenas com apreciações',
    },
    tabela: {
      titulo: 'Lista de Ativos ({{total}})',
      itensPorPagina: 'Itens por página:',
      colunaAreaLocal: 'Área / Local',
      colunaEquipamento: 'Equipamento',
      colunaTag: 'TAG',
      colunaApreciacoes: 'Apreciações',
      item: 'Item: {{item}}',
      contagemApreciacoes: '{{total}} apreciação(ões)',
      apreciacaoRevisao: '{{numero}} - Rev.{{revisao}}',
      maisApreciacoes: '+{{total}} mais',
      semApreciacoes: 'Sem apreciações',
      vazio: 'Nenhum ativo encontrado',
    },
    paginacao: {
      mostrando: 'Mostrando {{inicio}} a {{fim}} de {{total}}',
      pagina: 'Página {{pagina}} de {{total}}',
      anterior: 'Anterior',
      proxima: 'Próxima',
    },
    importacao: {
      semProjeto: 'Selecione um projeto primeiro',
      sucesso: 'Importação concluída!\n{{mensagem}}',
      erro: 'Erro na importação: {{mensagem}}',
      projetoInexistente: 'O projeto selecionado não existe mais no banco de dados. Por favor, selecione um projeto válido.',
      erroGenerico: 'Erro ao importar planilha. Verifique o console para mais detalhes.',
    },
  },
  en: {
    titulo: 'Asset Dashboard',
    subtitulo: 'List of all registered machines and equipment',
    acoes: {
      novaMaquina: 'New Machine',
      importar: 'Import Spreadsheet',
      importando: 'Importing...',
    },
    filtros: {
      titulo: 'Filters',
      limpar: 'Clear Filters',
      busca: 'Search',
      buscaPlaceholder: 'Equipment, TAG, Item...',
      apenasComApreciacoes: 'Only with risk assessments',
    },
    tabela: {
      titulo: 'Asset List ({{total}})',
      itensPorPagina: 'Items per page:',
      colunaAreaLocal: 'Area / Location',
      colunaEquipamento: 'Equipment',
      colunaTag: 'TAG',
      colunaApreciacoes: 'Risk Assessments',
      item: 'Item: {{item}}',
      contagemApreciacoes: '{{total}} risk assessment(s)',
      apreciacaoRevisao: '{{numero}} - Rev.{{revisao}}',
      maisApreciacoes: '+{{total}} more',
      semApreciacoes: 'No risk assessments',
      vazio: 'No assets found',
    },
    paginacao: {
      mostrando: 'Showing {{inicio}} to {{fim}} of {{total}}',
      pagina: 'Page {{pagina}} of {{total}}',
      anterior: 'Previous',
      proxima: 'Next',
    },
    importacao: {
      semProjeto: 'Select a project first',
      sucesso: 'Import finished!\n{{mensagem}}',
      erro: 'Import error: {{mensagem}}',
      projetoInexistente: 'The selected project no longer exists in the database. Please select a valid project.',
      erroGenerico: 'Could not import the spreadsheet. Check the console for more details.',
    },
  },
};
